import { createContext, useContext, useState } from "react";
import { T, LANGS } from "@/i18n";

const LangContext = createContext(null);

export const LangProvider = ({ children }) => {
  const [lang, setLangState] = useState(() => {
    const saved = localStorage.getItem("ps_lang");
    return LANGS.includes(saved) ? saved : "ru";
  });
  const setLang = (l) => {
    localStorage.setItem("ps_lang", l);
    setLangState(l);
  };
  return <LangContext.Provider value={{ lang, setLang, t: T[lang] }}>{children}</LangContext.Provider>;
};

export const useLang = () => useContext(LangContext);
